<template>
  <v-card>
    <v-card-title>
      Update Password
    </v-card-title>
    <v-card-subtitle>
      Change your password at any time
    </v-card-subtitle>
    <v-card-text>
      <v-form ref="form" v-model="valid">
        <v-row>
          <v-col cols="12" sm="6" md="4">
            <v-text-field
              v-model="password"
              label="Password"
              outlined
              maxlength="50"
              :rules="[$rules.required, $rules.password]"
              required
              type="password"
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="6" md="4">
            <v-text-field
              v-model="passwordConfirm"
              label="Confirm Password"
              outlined
              maxlength="50"
              :rules="passwordConfirmationRules"
              required
              type="password"
            ></v-text-field>
          </v-col>
        </v-row>
      </v-form>
    </v-card-text>
    <v-card-actions>
      <v-btn @click="save" :loading="saving">Update Password</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "UserProfilePasswordForm",
  components: {},
  data: () => ({
    valid: true,
    saving: false,
    loading: false,
    password: "",
    passwordConfirm: ""
  }),
  computed: {
    passwordConfirmationRules() {
      return [
        v => !this.password || this.password === v || "Passwords must match"
      ];
    },
    ...mapGetters({
      profile: "profile/profile"
    })
  },
  created() {},
  methods: {
    save() {
      if (this.$refs.form.validate()) {
        this.saving = true;
        this.$store
          .dispatch("profile/saveNewPassword", { password: this.password })
          .then(() => {
            this.$root.$snackbarSuccess("Password updated.");
            this.$refs.form.resetValidation();
          })
          .catch(error => {
            this.logError(error);
            this.$root.$alert(
              "Error Occurred",
              "An error occurred while updating your password."
            );
          })
          .finally(() => {
            this.saving = false;
          });
      }
    }
  }
};
</script>
